import React, { Component } from "react";
import _ from "lodash";
import { sendAPIRequest } from "shared/utils/requests";

class ApplicationSubmit extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };

  }

  async resendEmail() {
    const {
      applicantEmail,
    } = this.props;

    const response = await sendAPIRequest(`/transcriber_applicants/resend_email`, "POST", { email: applicantEmail });
    if (response.data.status == 'success') {
      this.setState({ emailResent: true });
    } else {
      throw new Error("invalid status for resent email: " + response.data.status)
    }
    alert('Email resent! It should be in your inbox in the next few minutes. If you don\'t see it, make sure to check your spam folder!');
  }

  render() {

    const {
      emailResent,
      emailResending,
    } = this.state;

    return (
      <div className="modal-container">
        <div className="modal-body">
          <div className="modal-title">
          <div className="modal-title-icon">
            <svg className="modal-title-icon-circle" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="13" cy="13" r="13" fill="#29D2A0"/>
            </svg>
            <svg className="modal-title-icon-check" width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.0115 2.42035L6.12053 9.93774L2.98828 6.52074" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div className="modal-title-title">
            Thanks for applying!
          </div>

          </div>
          <div className="modal-text modal-description">
            You should shortly receive a reply from no-reply@qa-world.com that will contain the link to a short transcription test.
            <br /><br />
            This is a quick test of your basic understanding of english audio comprehension, spelling and grammar. If you pass, you will be approved for paid transcription on the platform.
          </div>
          <div className="modal-bar" />
          <div className="modal-text modal-links">
            <div className="modal-links-link modal-links-message">
              If you didn’t get the email within a few hours, try:
            </div>
            <div className="modal-links-link">
              Check your Spam Folder
            </div>
            <div className="modal-links-link">
              <a className="modal-links-highlight" onClick={() => {
                  if(!emailResent && !emailResending) {
                    this.setState({ emailResending: true });
                    this.resendEmail();
                  }
                }}>
                Resend the confirmation email
              </a>
            </div>
            <div className="modal-links-link">
              Double check your email is correct and <a className="modal-links-highlight" href="/transcriber_applicants/signup" target="_blank"  rel="noopener noreferrer">re-apply</a>
            </div>
            <div className="modal-links-link">
              <a className="modal-links-highlight" href="https://www.facebook.com/qaworldcommunity/" target="_blank"  rel="noopener noreferrer">
                Contact us on Facebook
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

export default ApplicationSubmit;
